module.exports = __webpack_public_path__ + "a04b591d4d96c5e7480ae3a9b16d0e88.png";